export default __webpack_public_path__ + "static/media/science_icon.7e17ce7f.svg";